import MobileWeekCalendar from "./MobileWeekCalendar";

export default MobileWeekCalendar;